import React from 'react';
interface CardProps {
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}
export const Card: React.FC<CardProps> = ({
  title,
  children,
  footer,
  className = ''
}) => {
  return <div className={`bg-white rounded-lg shadow overflow-hidden ${className}`}>
      {title && <div className="border-b border-gray-200 px-6 py-4">
          <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        </div>}
      <div className="px-6 py-4">{children}</div>
      {footer && <div className="border-t border-gray-200 px-6 py-4 bg-gray-50">
          {footer}
        </div>}
    </div>;
};